import { cn } from "@/lib/utils";
import { Button } from "@/components/ui/button";
import { Icon } from "@/components/ui/icon";
import { ContactCreditCost } from "./credit-cost";

/** Credits charged to reveal/enrich a single profile's contact info. */
export const CONTACT_REVEAL_CREDITS = 2;

type ContactRevealTriggerProps = React.ComponentProps<"button"> & {
  /**
   * "reveal" for profiles sourced from our own search pool, "enrich" for
   * imported / ATS profiles where we're augmenting data the user supplied.
   */
  action?: "reveal" | "enrich";
};

export function CandidateContactRevealTrigger({
  className,
  action = "reveal",
  ...props
}: ContactRevealTriggerProps) {
  const verb = action === "enrich" ? "Enrich" : "Reveal";
  return (
    <Button
      type="button"
      variant={"linear-contact"}
      size={"xs"}
      {...props}
      className={cn(
        "rounded-full gap-1.5 items-center h-8 sm:h-5.5",
        className,
      )}
    >
      <Icon
        name="IconEmail1Sparkle"
        size={14}
        className="text-contact shrink-0 size-3.5"
      />
      <span className="md:hidden">{verb} Contact</span>
      <span className="hidden md:inline">{verb} Contact Details</span>
      <ContactCreditCost credits={CONTACT_REVEAL_CREDITS} />
    </Button>
  );
}
